import React, { FC } from 'react';
import { StyledSection, StyledList, StyledT, StyledP } from './AvailableDocumentsGroup.styles';
import { AvailableDocumentGroup } from '../../../../interfaces/AvailableDocumentGroup';

export interface AvailableDocumentsGroupProps {
  group: AvailableDocumentGroup;
}

const AvailableDocumentsGroup: FC<AvailableDocumentsGroupProps> = ({ group }) => (
  <StyledSection>
    <StyledT>{group.type}</StyledT>
    <StyledList>
      {group.documents.map((x) => (<li key={x.name}><StyledP>{x.name}</StyledP></li>))}
    </StyledList>
  </StyledSection>

);

export default AvailableDocumentsGroup;
